var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFullLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2",
    viewBox: "0 0 435.63 155",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_2);\n      }\n\n      .cls-2 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_2-2);\n      }\n\n      .cls-3 {\n        fill: #e9ecef;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_2",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 2",
    x1: 40.69,
    y1: 145.32,
    x2: 106.01,
    y2: 7.12,
    gradientTransform: "translate(0 154) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#f8f9fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#adb5bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_2-2",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 2",
    x1: 49.34,
    y1: 125.88,
    x2: 94.51,
    y2: 32.44,
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LOGO"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m85.42,0v14.09l48.81,28.18v23.02h12.2v-30.07L85.42,0Zm48.81,89.7v23.02l-48.81,28.18v14.09l61.01-35.23v-30.07h-12.2Zm-122.02,0H0v30.07l61.01,35.23v-14.09l-48.81-28.18v-23.02ZM0,35.23v30.07h12.2v-23.02L61.01,14.09V0L0,35.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m85.42,126.82l12.2-7.05v-36.74h12.2v29.69l12.2-7.04v-56.36l-12.2-7.05v28.56h-12.2v-35.6l-12.2-7.04-12.2-7.04-12.2,7.04-12.2,7.04v35.6h-12.2v-28.56l-12.2,7.05v56.36l12.2,7.04v-29.69h12.2v36.74l12.2,7.05V42.27l12.2-7.04,12.2,7.04v84.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m223.18,69.59h-9.33v-15.02h-19.71v15.02h-9.33v-36.9h9.33v14.13h19.71v-14.13h9.33v36.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m230.87,51.15c0-12.44,8.43-19.14,21.93-19.14,15.02,0,22.3,7.22,22.3,19.14,0,13.23-8.54,19.14-22.03,19.14-14.34,0-22.19-6.64-22.19-19.14h0Zm34.32,0c0-7.86-4.16-11.54-12.44-11.54-7.59,0-11.97,3.8-11.97,11.54s4.58,11.49,12.65,11.49,11.76-3.64,11.76-11.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m310.04,32.7h9.28v21.61c0,11.55-6.17,15.97-18.5,15.97-11.65,0-18.45-4.06-18.45-16.03v-21.56h9.28v20.35c0,6.17,2.01,9.17,9.17,9.17,7.64,0,9.23-3.06,9.23-9.17v-20.35h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m327.11,60.42c2.05,1.11,6.7,2.43,12.02,2.43s7.64-1.27,7.64-3.8c0-2.69-2.05-3.21-7.75-4.8l-1.63-.42c-7.75-1.95-10.7-5.64-10.7-10.91,0-7.01,5.9-10.91,15.97-10.91,5.75,0,9.38.74,11.65,1.63v7.43c-3.38-1.05-7.69-1.53-11.07-1.53-4.69,0-7.01,1.06-7.01,3.21,0,2.26,2.64,3,8.96,4.85l1.74.47c8.17,2.37,10.01,6.06,10.01,10.54,0,7.54-6.53,11.65-16.92,11.65-5.43,0-9.54-.9-12.91-2.22v-7.64h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m393.26,69.59h-29.21v-36.9h29.21v7.54h-19.87v7.06h17.55v7.01h-17.55v7.7h19.87v7.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m223.18,122.3h-9.33v-15.02h-19.71v15.02h-9.33v-36.9h9.33v14.13h19.71v-14.13h9.33v36.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m259.76,85.41h9.28v21.61c0,11.54-6.17,15.97-18.5,15.97-11.65,0-18.45-4.06-18.45-16.03v-21.56h9.28v20.34c0,6.17,2.01,9.17,9.17,9.17,7.64,0,9.23-3.06,9.23-9.17v-20.34h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m316.16,122.3h-10.28l-18.87-25.78v25.78h-9.06v-36.9h10.96l18.24,25.03v-25.03h9.02v36.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m344.56,122.3h-9.33v-28.89h-13.18v-8.01h35.63v8.01h-13.12v28.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m392.79,122.3h-29.21v-36.9h29.21v7.54h-19.87v7.06h17.55v7.01h-17.55v7.69h19.87v7.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m400,85.41h16.87c11.44,0,15.86,4.01,15.86,11.65,0,5.69-2.43,9.33-7.91,11.17l10.81,14.07h-10.39l-9.65-12.86h-6.27v12.86h-9.33v-36.9h0Zm9.12,16.97h7.22c4.43,0,6.69-1.42,6.69-4.8,0-3.16-1.84-4.58-7.27-4.58h-6.64v9.38h0Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullLogo);
export default __webpack_public_path__ + "static/media/full-logo.b53c46c79084324fcf44655d321d1b63.svg";
export { ForwardRef as ReactComponent };